import React from "react";

function Skills({ skill = "HTML5", value = "95%", width = "95" }) {
  return (
    <div className="progress">
      <span className="skill">
        {skill} <i className="val">{value}</i>
      </span>
      <div className="progress-bar-wrap">
        <div
          className="progress-bar"
          role="progressbar"
          style={{ width: `${width}%` }}
        ></div>
      </div>
    </div>
  );
}

export default Skills;
